module.exports = __webpack_public_path__ + "img/emsbanner5.17fec6f2.png";